import React from 'react';
import styles from './styles.module.scss';
import { SlideAnswer } from '../../types';

interface ChoiceGridProps {
  answers: SlideAnswer[];
  selectedValue?: string;
  onSelect: (value: string) => void;
  columns?: 1 | 2 | 3;
}

const ChoiceGrid: React.FC<ChoiceGridProps> = ({
  answers,
  selectedValue,
  onSelect,
}) => {
  return (
    <div className={styles.choiceGrid} role="group">
      {answers.map((answer) => {
        const selected = selectedValue === answer.value;
        const recommended = Boolean(answer.badge) && !selected;
        return (
          <button
            key={answer.value}
            type="button"
            className={`${styles.choiceOption} ${selected ? styles.selected : ''} ${
              recommended ? styles.recommended : ''
            }`}
            aria-pressed={selected}
            onClick={() => onSelect(answer.value)}
          >
            {answer.badge && <span className={styles.cornerBadge}>{answer.badge}</span>}
            <span className={styles.copy}>
              <span className={styles.titleRow}>
                <span className={styles.optionLabel}>{answer.label}</span>
              </span>
              {answer.description && <span className={styles.description}>{answer.description}</span>}
              {answer.badges && answer.badges.length > 0 && (
                <span className={styles.badgeRow}>
                  {answer.badges.map((badge) => (
                    <span
                      key={badge}
                      className={`${styles.badge} ${
                        answer.badgeTone === 'gray' ? styles.badgeGray : ''
                      }`}
                    >
                      {badge}
                    </span>
                  ))}
                </span>
              )}
            </span>
            <span className={styles.mark} aria-hidden="true" />
          </button>
        );
      })}
    </div>
  );
};

export default ChoiceGrid;
